import React, { useState, useMemo } from "react";
import PageContainer from "../../components/PageContainer";
import Masonry from "../../components/Masonry/Masonry";
import { SingleGalleryDialog } from "./dialogs/SingleGalleryDialog";
import { useGalleries } from "../../hooks/useGalleries";
import { CircularProgress, Box } from "@mui/material";
import { shuffle } from "../../utils/shuffle";

export default function Home() {
    const [openGallery, setOpenGallery] = useState(false);
    const [galleryId, setGalleryId] = useState(-1);
    
    const { data: rawGalleries, isLoading, isError } = useGalleries();

    // Veriyi sadece API'den geldiğinde veya değiştiğinde karıştırıyoruz.
    // Modal açıldığında (openGallery değiştiğinde) burası tetiklenmez.
    const galleriesData = useMemo(() => {
        return rawGalleries ? shuffle(rawGalleries) : [];
    }, [rawGalleries]);

    if (isLoading) {
        return (
            <PageContainer title="EserUyanik Photography">
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
                    <CircularProgress color="inherit" />
                </Box>
            </PageContainer>
        );
    }

    if (isError) {
        return (
            <PageContainer title="EserUyanik Photography">
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
                    Veriler yüklenirken bir hata oluştu.
                </Box>
            </PageContainer>
        );
    }

    return (
        <PageContainer title="EserUyanik Photography">
            {galleryId > -1 && (
                <SingleGalleryDialog
                    open={openGallery}
                    setOpen={setOpenGallery}
                    galleryId={galleryId}
                    setGalleryId={setGalleryId}
                />
            )}
            <Masonry
                data={galleriesData}
                setGalleryId={setGalleryId}
                setGalleryOpen={setOpenGallery}
            />
        </PageContainer>
    );
}
